import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./edit-documents-dialog.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./edit-documents-dialog.component.scss?ngResource";
import { Component, Input } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { AppControllerService } from "../../../../app-controller.service";
import { AlertType } from "../../../../shared/models/alert";
import { UserInformationService } from "../../../../shared/services/user/user-information.service";
import { ApplicationCreateService } from "../../application-create.service";
import { SubscriberComponent } from "../../../../shared/components/subscriber/subscriber.component";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
import { SaLongDatePipe } from "../../../../shared/pipes/sa-long-date/sa-long-date.pipe";
import { EditDocumentsDialogConstants } from "./edit-documents-dialog.constants";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { RequestStatusService } from "../../../../shared/services/request-status/request-status.service";
export let EditDocumentsDialogComponent = class EditDocumentsDialogComponent extends SubscriberComponent {
    activeModal;
    appControllerService;
    userInformationService;
    applicationCreateService;
    requestStatusService;
    saLongDatePipe;
    editDocumentForm;
    documentTypes = [];
    dialogTitle = "";
    documentToEdit;
    configUploadSettings;
    currentApplication;
    documentTypeLabel = EditDocumentsDialogConstants.DOCUMENT_TYPE_LABEL;
    descriptionLabel = EditDocumentsDialogConstants.DESCRIPTION_LABEL;
    fileLabel = EditDocumentsDialogConstants.FILE_LABEL;
    selectFileLabel = EditDocumentsDialogConstants.SELECT_FILE_LABEL;
    cancelBtnLabel = EditDocumentsDialogConstants.CANCEL_BTN_PLACEHOLDER;
    documentTypeFormControlName = EditDocumentsDialogConstants.DOCUMENT_TYPE_FORM_CONTROL;
    descriptionFormControlName = EditDocumentsDialogConstants.DESCRIPTION_FORM_CONTROL;
    saveBtnLabel = EditDocumentsDialogConstants.SAVE_BTN_LABEL;
    uploadedFiles = [];
    documentTypeErrMsg = EditDocumentsDialogConstants.DOCUMENT_TYPE_ERR_MSG;
    descriptionErrMsg = EditDocumentsDialogConstants.DESCRIPTION_ERR_MSG;
    noFileUploadedErrMsg = EditDocumentsDialogConstants.NO_FILE_UPLOADED_ERR_MSG;
    uploadedFileTooBigErrMsg = EditDocumentsDialogConstants.UPLOADED_FILE_TOO_BIG_ERR_MSG;
    filetypeNotAllowedErrMsg = EditDocumentsDialogConstants.UPLOADED_FILE_TYPE_NOT_ALLOWED_ERR_MSG;
    componentName = EditDocumentsDialogConstants.COMPONENT_NAME;
    fileDetails;
    maxFileSize;
    allowedFileTypes = [];
    documentUploadedBy;
    fileString;
    fileBlob;
    constructor(activeModal, appControllerService, userInformationService, applicationCreateService, requestStatusService, saLongDatePipe) {
        super();
        this.activeModal = activeModal;
        this.appControllerService = appControllerService;
        this.userInformationService = userInformationService;
        this.applicationCreateService = applicationCreateService;
        this.requestStatusService = requestStatusService;
        this.saLongDatePipe = saLongDatePipe;
    }
    ngOnInit() {
        this.initForm();
        this.getAttachmentFileContent(this.documentToEdit.id);
        this.setFormValues();
        this.userInformationService.$authenticatedUser.subscribe((userInfo) => {
            this.documentUploadedBy = `${userInfo.lastName} ${userInfo.firstName}`;
        });
        this.maxFileSize = this.configUploadSettings.maximumSize;
        this.allowedFileTypes = this.configUploadSettings.agsSupportedAttachmentFileTypes.split(",");
    }
    onCancelBtnClicked() {
        this.activeModal.close();
    }
    onSaveBtnClicked() {
        if (this.editDocumentForm.valid && this.uploadedFiles.length > 0) {
            try {
                this.requestStatusService.clearBusyRequestCounter();
                this.requestStatusService.showBusySpinner("save");
                const editedDocument = {
                    id: this.documentToEdit.id,
                    type: this.editDocumentForm.get(this.documentTypeFormControlName).value,
                    name: this.editDocumentForm.get(this.descriptionFormControlName).value,
                    fileName: this.fileDetails ? this.fileDetails.name : this.documentToEdit.fileName,
                    dateUploaded: this.saLongDatePipe.transform(new Date().getTime().toString())
                };
                this.uploadAttachment(editedDocument);
            }
            catch (e) {
                this.appControllerService.showMessage("Something went wrong uploading the selected attachment. please contact your system administrator.", AlertType.Warning);
                this.requestStatusService.removeBusySpinner("save");
            }
        }
        else {
            this.markAllControlsAsTouched();
            this.appControllerService.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Warning);
        }
        this.requestStatusService.removeBusySpinner("save");
    }
    deleteAttachment(i, $event) {
        if (this.uploadedFiles.length > 0) {
            this.uploadedFiles.splice(i, 1);
        }
        $event.stopPropagation();
    }
    onFileSelected(event) {
        this.requestStatusService.clearBusyRequestCounter();
        this.requestStatusService.showBusySpinner("upload");
        try {
            this.fileDetails = null;
            let file;
            if (event.target) {
                file = event.target.files[0];
            }
            else {
                file = event.item(0);
            }
            ;
            if (file) {
                const fileName = file.name;
                const uploadedFileSize = file.size;
                const fileExtension = fileName.split(".").pop();
                if (uploadedFileSize > this.maxFileSize) {
                    this.appControllerService.showMessage(this.uploadedFileTooBigErrMsg, AlertType.Warning);
                    return;
                }
                let fileTypeAllowed = false;
                for (const allowedFileType of this.allowedFileTypes) {
                    if (allowedFileType.trim().toUpperCase() === fileExtension.trim().toUpperCase()) {
                        fileTypeAllowed = true;
                        break;
                    }
                }
                if (fileTypeAllowed) {
                    this.fileDetails = file;
                    this.uploadedFiles[0] = file.name;
                }
                else {
                    this.appControllerService.showMessage(this.filetypeNotAllowedErrMsg, AlertType.Warning);
                }
            }
        }
        catch (e) {
            this.appControllerService.showMessage("Something went wrong uploading the selected attachment. please contact your system administrator.", AlertType.Warning);
            this.requestStatusService.removeBusySpinner("upload");
        }
        this.requestStatusService.removeBusySpinner("upload");
    }
    uploadAttachment(editedDoc) {
        const reader = new FileReader();
        let fileString;
        if (this.fileDetails) {
            reader.readAsDataURL(this.fileDetails);
        }
        else {
            reader.readAsDataURL(this.fileBlob);
        }
        reader.onloadend = (evt) => {
            if (evt.target.readyState === FileReader.DONE) {
                const bytes = reader.result;
                if (bytes.includes(",")) {
                    fileString = bytes.substring(bytes.indexOf(",") + 1);
                }
                const params = {
                    AppId: this.currentApplication.appId,
                    ModuleId: this.appControllerService.selectedModuleID,
                    FileName: editedDoc.fileName,
                    Data: fileString,
                    Description: editedDoc.name,
                    AttachmentType: editedDoc.type,
                    ComponentType: "Upload AFLA portal required documents",
                    AFLAPortalObjectId: 0,
                    UploadedBy: this.documentUploadedBy
                };
                this.cleanupAfterDestroy(this.applicationCreateService.uploadDocumentObservable(params)).subscribe({
                    next: (attachment) => {
                        const attachmentObject = {
                            id: attachment.id,
                            type: attachment.attachmentType,
                            name: attachment.description,
                            dateUploaded: this.saLongDatePipe.transform(attachment.date),
                            fileName: attachment.fileName,
                        };
                        const deletedParams = {
                            ids: [this.documentToEdit.id], moduleId: this.appControllerService.selectedModuleID
                        };
                        this.cleanupAfterDestroy(this.applicationCreateService.deleteUploadDocumentsObservable(deletedParams)).subscribe({
                            next: () => {
                                const resultObject = {
                                    idsToDelete: [this.documentToEdit.id], editedDocument: attachmentObject
                                };
                                this.activeModal.close(resultObject);
                            }, error: (error) => {
                                this.appControllerService.handleServerErrorMessage(this.componentName, error, CRUDOperation.Add);
                            }
                        });
                    }, error: (error) => {
                        this.appControllerService.handleServerErrorMessage(this.componentName, error, CRUDOperation.Update);
                    }
                });
            }
        };
    }
    initForm() {
        this.editDocumentForm = new FormGroup({
            documentType: new FormControl(this.documentToEdit.type, Validators.required),
            description: new FormControl(this.documentToEdit.name, Validators.required),
            fileName: new FormControl(this.documentToEdit.fileName)
        });
    }
    setFormValues() {
        this.editDocumentForm.get(this.documentTypeFormControlName).setValue(this.documentToEdit.type);
        this.editDocumentForm.get(this.descriptionFormControlName).setValue(this.documentToEdit.name);
        this.uploadedFiles[0] = this.documentToEdit.fileName;
    }
    markAllControlsAsTouched() {
        Object.keys(this.editDocumentForm.controls).forEach(key => {
            if (this.editDocumentForm.get(key).invalid) {
                this.editDocumentForm.get(key).markAsTouched();
            }
        });
    }
    getAttachmentFileContent(id) {
        this.cleanupAfterDestroy(this.applicationCreateService.getAttachmentContent(id)).subscribe({
            next: (fileBlob) => {
                this.fileBlob = fileBlob;
            }, error: (error) => {
                this.appControllerService.handleServerErrorMessage(this.componentName, error, CRUDOperation.Get);
            }
        });
    }
    static ctorParameters = () => [
        { type: NgbActiveModal },
        { type: AppControllerService },
        { type: UserInformationService },
        { type: ApplicationCreateService },
        { type: RequestStatusService },
        { type: SaLongDatePipe }
    ];
    static propDecorators = {
        documentTypes: [{ type: Input }],
        dialogTitle: [{ type: Input }],
        documentToEdit: [{ type: Input }],
        configUploadSettings: [{ type: Input }],
        currentApplication: [{ type: Input }]
    };
};
EditDocumentsDialogComponent = __decorate([
    Component({
        selector: "app-edit-documents-dialog",
        template: __NG_CLI_RESOURCE__0,
        host: { 'edit-documents-dialog': 'create-application' },
        styles: [__NG_CLI_RESOURCE__1]
    })
], EditDocumentsDialogComponent);
